export default [
  {
    path: '/versions/:id?',
    name: 'versions',
    component: () => import('@/views/modules/skeleton/admin/versions/versions.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Versions',
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/add-version',
    name: 'add_version',
    component: () => import('@/views/modules/skeleton/admin/versions/CreateVersion.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Add version',
          active: true,
          redirectIfLoggedIn: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/edit-version/:id',
    name: 'edit_version',
    component: () => import('@/views/modules/skeleton/admin/versions/CreateVersion.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Edit version',
          active: true,
          redirectIfLoggedIn: true,
          back: true,
        },
      ],
    },
  },
]
